import { Component, OnInit } from '@angular/core';
import { AdminHotelNavbarComponent } from '../../../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosService } from '../../../../services/productos.service';
import { TokenStorageService } from '../../../../services/token-storage.service';
import { NavbarComponent } from "../../../../components/navbar/navbar.component";

interface Producto {
  productId: string;
  hotelId: string;
  name: string;
  description: string;
  price: number;
  tax_rate: number;
  stock: number;
  created_at: string;
  updated_at: string;
}

@Component({
  selector: 'app-gestionar-productos',
  imports: [AdminHotelNavbarComponent, FooterComponent, CommonModule, NavbarComponent],
  templateUrl: './gestionar-productos.component.html',
  styleUrl: './gestionar-productos.component.css'
})
export class GestionarProductosComponent implements OnInit {
  alojamientoId: string = '';
  alojamientoName: string = '';
  productos: Producto[] = [];
  productoAEliminar: Producto | null = null;
  mostrarModalEliminar: boolean = false;
  cargando: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productosService: ProductosService,
    private tokenStorage: TokenStorageService,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const alojamientoIdParam = params.get('alojamientoId');
      if (alojamientoIdParam) {
        this.alojamientoId = alojamientoIdParam;
      } else {
        console.error('No se encontró alojamientoId en la URL');
      }
      const alojamientoNameParam = params.get('alojamientoName');
      if (alojamientoNameParam) {
        this.alojamientoName = alojamientoNameParam;
      } else {
        console.error('No se encontró alojamientoName en la URL');
      }
    });
    this.consultarProductosPorAlojamiento(this.alojamientoId);
  }

  consultarProductosPorAlojamiento(hotelId: string) {
    if (!this.alojamientoId) return;

    this.cargando = true;
    this.productosService.consultarProductosPorAlojamiento(hotelId, this.tokenStorage.getAccessToken() || '').subscribe({
      next: data => {
        this.productos = data.productos;
        this.cargando = false;
      },
      error: err => {
        console.error('Error al consultar productos:', err);
        this.cargando = false;
      }
    });
  }

  irACrearProducto() {
    this.router.navigate(
      ['/admin-hotel/inventario/crear-producto'], {
      queryParams: {
        alojamientoId: this.alojamientoId,
        alojamientoName: this.alojamientoName,
      }
    });
  }

  editarProducto(producto: Producto) {
    console.log(producto)

    
    this.router.navigate(
      [`/admin-hotel/inventario/editar-producto/${producto.productId}`], {
      queryParams: {
        alojamientoId: this.alojamientoId,
        alojamientoName: this.alojamientoName,
      }
    });
  }

  abrirModalEliminar(producto: Producto) {
    this.productoAEliminar = producto;
    this.mostrarModalEliminar = true;
  }

  cerrarModalEliminar() {
    this.productoAEliminar = null;
    this.mostrarModalEliminar = false;
  }

  confirmarEliminarProducto() {
    if (!this.productoAEliminar) return;

    this.productosService.eliminarProducto(
      this.productoAEliminar.productId,
      this.alojamientoId,
      this.tokenStorage.getAccessToken() || ''
    ).subscribe({
      next: () => {
        this.productos = this.productos.filter(p => p.productId !== this.productoAEliminar?.productId);
        this.cerrarModalEliminar();
      },
      error: err => {
        console.error('Error al eliminar producto:', err);
        this.cerrarModalEliminar();
      }
    });
  }
}
